"use strict";

import BaseEditController from "dias/ui/formsteps/formstepBaseEdit.controller.js";


class KAufgabeEditBeschreibungController extends BaseEditController {
  /*@ngInject*/
  constructor($q, $scope, ParameterUtils, DiasNotification, Restangular, i18n) {
    super($q, $scope, DiasNotification);
    this.ParameterUtils = ParameterUtils;
    this.gettext = i18n.gettext;
    this.Restangular = Restangular;
    this.initForm();
  }

  _save() {
    const data = this.ParameterUtils.to_request_body(this.formModel, null, "");
    Object.assign(this.model, data, {});
    return this.Restangular
      .one("sitzungen", this.model.sitzung.pk)
      .one("tops", this.model.top.pk)
      .one("sitzungslisten", this.model.sitzungsliste)
      .one("festgeschrieben", this.model.pk)
      .customPUT(
        data,
        "protokoll_bearbeiten"
      ).then(
        response => {
          this.$scope.model.sla_protokoll = response.sla_protokoll;
          this.DiasNotification.page.success("Änderungen erfolgreich gespeichert");
        },
        errors => {
          return this.onErrors(errors, this.errorLabels);
        }
      );
  }

  onEnterEditMode() {
    super.onEnterEditMode();
    this.updateFormModel();
  }

  updateFormModel() {
    if (this.ParameterUtils && this.formModelTemplate && this.model) {
      this.formModel = this.ParameterUtils.params_from_template(this.formModelTemplate, this.model);
    }
  }

  initForm() {
    this.formModelTemplate = this.ParameterUtils.init_parameter_in({
      sla_protokoll: {
        bez: this.gettext("Protokoll"),
        typ: "richtext",
        prio: 1,
        options: {
          required: false
        }
      },
    });
    this.form_keys = this.ParameterUtils.get_ordered_keys(this.formModelTemplate);
    this.errorLabels = {};
    this.form_keys.forEach(
      k => {
        this.errorLabels[k] = `${ this.formModelTemplate[k].bez }: `;
      }
    );
    this.updateFormModel();
  }
}

export default KAufgabeEditBeschreibungController;
